export const TASK_STATE_OPEN = "open";
export const TASK_STATE_COMPLETED = "done";
